import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';

const stylesToInject = [
  { id: 'recycla-font-maven-pro', href: '//cdn2.editmysite.com/fonts/Maven_Pro/font.css?2' },
  { id: 'recycla-font-playfair', href: '//cdn2.editmysite.com/fonts/Playfair_Display/font.css?2' },
  { id: 'recycla-font-open-sans', href: '//cdn2.editmysite.com/fonts/Open_Sans/font.css?2' },
  { id: 'recycla-font-montserrat', href: '//cdn2.editmysite.com/fonts/Montserrat/font.css?2' },
  { id: 'recycla-font-oxygen', href: '//cdn2.editmysite.com/fonts/Oxygen/font.css?2' },
  { id: 'recycla-font-catamaran', href: '//cdn2.editmysite.com/fonts/Catamaran/font.css?2' },
  { id: 'recycla-font-quicksand', href: '//cdn2.editmysite.com/fonts/Quicksand/font.css?2' },
  { id: 'recycla-social-icons', href: '//cdn11.editmysite.com/css/social-icons.css?buildtime=1784563224' },
  { id: 'recycla-theme-css', href: '/theme.css' },
];

stylesToInject.forEach(({ id, href }) => {
  if (document.getElementById(id)) return;
  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.href = href;
  document.head.appendChild(link);
});

createRoot(document.getElementById('root')).render(<App />);
